var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.timestamp !== 0
    ? _c(
        "time",
        {
          attrs: {
            datetime: _vm.datetime,
            title: _vm.title,
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.formatted_date()) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }